var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"comment-icon-wrapper"},[_c('q-icon',{staticClass:"comment-icon",class:{ active: _vm.isActive },attrs:{"name":"comment_bank"},on:{"click":function($event){$event.stopPropagation();return _vm.activateComment.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }